import { useCallback, useMemo } from 'react';
import { useBoardDispatch, useBoardSelector } from '../redux/reduxHooks';
import { getSelectedCardIds, setCardsSelected } from '../redux/selectionSlice';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAllCheckboxHeader = ({
  cardIds
}) => {
  const selectedCardIds = useBoardSelector(getSelectedCardIds);
  const isCurrentPageSelected = useMemo(() => cardIds.length > 0 && cardIds.every(cardId => selectedCardIds.has(cardId)), [cardIds, selectedCardIds]);
  const dispatch = useBoardDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => {
    dispatch(setCardsSelected({
      cards: cardIds.map(cardId => ({
        cardId,
        selected: checked
      }))
    }));
  }, [dispatch, cardIds]);
  return /*#__PURE__*/_jsx(Checkbox, {
    "data-test-id": "checkbox-select-all",
    checked: isCurrentPageSelected,
    indeterminate: selectedCardIds.size > 0,
    onChange: handleChange
  });
};
export default SelectAllCheckboxHeader;